import { BasicFollowUpOrderDetailsComponent } from "./basic-follow-up-order-details/basic-follow-up-order-details.component";
import { GenericFollowUpOrderDetailsComponent } from "./generic-follow-up-order-details/generic-follow-up-order-details.component";
import { CommonModule } from "@angular/common";
import { ConsultOrderDetailsComponent } from "./consult-order-details/consult-order-details.component";
import { ConsultOrderElsewhereCompletionComponent } from "./consult-order-elsewhere-completion/consult-order-elsewhere-completion.component";
import { DateEntryComponent } from "./date-entry/date-entry.component";
import { DetailsComponent } from "./details/details.component";
import { FeedbackComponent } from "./feedback/feedback.component";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { LabOrderDetailsComponent } from "./lab-order-details/lab-order-details.component";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { NgModule } from "@angular/core";
import { OverviewComponent } from "./overview/overview.component";
import { SharedModule } from "../shared/shared.module";
import { SurveyOrderDetailsComponent } from "./survey-order-details/survey-order-details.component";
import { TaskComponent } from "./task/task.component";
import { TaskOptionsComponent } from "./task-options/task-options.component";
import { TaskRoutingModule } from "./task-routing.module";
import { VaccineOrderCompletionComponent } from "./vaccine-order-completion/vaccine-order-completion.component";
import { VaccineOrderDetailsComponent } from "./vaccine-order-details/vaccine-order-details.component";
import { VisitFollowUpOrderCompletionComponent } from "./visit-follow-up-order-completion/visit-follow-up-order-completion.component";
import { VisitFollowUpOrderDetailsComponent } from "./visit-follow-up-order-details/visit-follow-up-order-details.component";

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    NgbModule,
    ReactiveFormsModule,
    SharedModule,
    TaskRoutingModule,
  ],
  declarations: [
    OverviewComponent,
    TaskComponent,
    DetailsComponent,
    ConsultOrderDetailsComponent,
    ConsultOrderElsewhereCompletionComponent,
    LabOrderDetailsComponent,
    VaccineOrderDetailsComponent,
    BasicFollowUpOrderDetailsComponent,
    GenericFollowUpOrderDetailsComponent,
    VisitFollowUpOrderDetailsComponent,
    SurveyOrderDetailsComponent,
    FeedbackComponent,
    DateEntryComponent,
    VaccineOrderCompletionComponent,
    VisitFollowUpOrderCompletionComponent,
    TaskOptionsComponent,
  ],
  providers: [],
})
export class TaskModule {}
